import { useState, useCallback } from 'react';
import {
  fetchUsergroups,
  createUsergroup,
  updateUsergroup,
  deleteUsergroup,
  type UsergroupInput,
} from '../services/master.service';
import type { Usergroup } from '../types';

export function useUsergroup() {
  const [usergroups, setUsergroups] = useState<Usergroup[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadUsergroups = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setUsergroups(await fetchUsergroups());
    } catch (e) {
      setError(e instanceof Error ? e.message : '部署の取得に失敗しました');
    } finally {
      setLoading(false);
    }
  }, []);

  const addUsergroup = useCallback(async (data: UsergroupInput): Promise<Usergroup> => {
    const created = await createUsergroup(data);
    setUsergroups((prev) => [created, ...prev]);
    return created;
  }, []);

  const editUsergroup = useCallback(async (id: string, data: Partial<UsergroupInput>): Promise<Usergroup> => {
    const updated = await updateUsergroup(id, data);
    setUsergroups((prev) => prev.map((x) => (x.id === id ? updated : x)));
    return updated;
  }, []);

  const removeUsergroup = useCallback(async (id: string): Promise<void> => {
    await deleteUsergroup(id);
    setUsergroups((prev) => prev.filter((x) => x.id !== id));
  }, []);

  return { usergroups, loading, error, loadUsergroups, addUsergroup, editUsergroup, removeUsergroup };
}
